/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {
  Component,
  ViewEncapsulation,
  ChangeDetectionStrategy,
  Directive,
  Input,
} from '@angular/core';
/**
 * Content of a card, needed as it's used as a selector in the API.
 * \@docs-private
 */
export class MdCardContent {static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: 'md-card-content, mat-card-content',
  host: {'class': 'mat-card-content'}
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function MdCardContent_tsickle_Closure_declarations() {
/** @type {?} */
MdCardContent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdCardContent.ctorParameters;
}

/**
 * Title of a card, needed as it's used as a selector in the API.
 * \@docs-private
 */
export class MdCardTitle {static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: `md-card-title, mat-card-title, [md-card-title], [mat-card-title],
             [mdCardTitle], [matCardTitle]`,
  host: {
    'class': 'mat-card-title'
  }
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function MdCardTitle_tsickle_Closure_declarations() {
/** @type {?} */
MdCardTitle.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdCardTitle.ctorParameters;
}

/**
 * Sub-title of a card, needed as it's used as a selector in the API.
 * \@docs-private
 */
export class MdCardSubtitle {static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: `md-card-subtitle, mat-card-subtitle, [md-card-subtitle], [mat-card-subtitle],
             [mdCardSubtitle], [matCardSubtitle]`,
  host: {
    'class': 'mat-card-subtitle'
  }
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function MdCardSubtitle_tsickle_Closure_declarations() {
/** @type {?} */
MdCardSubtitle.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdCardSubtitle.ctorParameters;
}

/**
 * Action section of a card, needed as it's used as a selector in the API.
 * \@docs-private
 */
export class MdCardActions {
/**
 * Position of the actions inside the card.
 */
align: 'start' | 'end' = 'start';
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: 'md-card-actions, mat-card-actions',
  host: {
    'class': 'mat-card-actions',
    '[class.mat-card-actions-align-end]': 'align === "end"',
  }
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'align': [{ type: Input },],
};
}

function MdCardActions_tsickle_Closure_declarations() {
/** @type {?} */
MdCardActions.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdCardActions.ctorParameters;
/** @type {?} */
MdCardActions.propDecorators;
/**
 * Position of the actions inside the card.
 * @type {?}
 */
MdCardActions.prototype.align;
}

/**
 * Footer of a card, needed as it's used as a selector in the API.
 * \@docs-private
 */
export class MdCardFooter {static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: 'md-card-footer, mat-card-footer',
  host: {'class': 'mat-card-footer'}
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function MdCardFooter_tsickle_Closure_declarations() {
/** @type {?} */
MdCardFooter.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdCardFooter.ctorParameters;
}

/**
 * Image used in a card, needed to add the mat- CSS styling.
 * \@docs-private
 */
export class MdCardImage {static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[md-card-image], [mat-card-image], [mdCardImage], [matCardImage]',
  host: {'class': 'mat-card-image'}
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function MdCardImage_tsickle_Closure_declarations() {
/** @type {?} */
MdCardImage.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdCardImage.ctorParameters;
}

/**
 * Image used in a card, needed to add the mat- CSS styling.
 * \@docs-private
 */
export class MdCardSmImage {static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[md-card-sm-image], [mat-card-sm-image], [mdCardImageSmall], [matCardImageSmall]',
  host: {'class': 'mat-card-sm-image'}
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function MdCardSmImage_tsickle_Closure_declarations() {
/** @type {?} */
MdCardSmImage.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdCardSmImage.ctorParameters;
}

/**
 * Image used in a card, needed to add the mat- CSS styling.
 * \@docs-private
 */
export class MdCardMdImage {static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[md-card-md-image], [mat-card-md-image], [mdCardImageMedium], [matCardImageMedium]',
  host: {'class': 'mat-card-md-image'}
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function MdCardMdImage_tsickle_Closure_declarations() {
/** @type {?} */
MdCardMdImage.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdCardMdImage.ctorParameters;
}

/**
 * Image used in a card, needed to add the mat- CSS styling.
 * \@docs-private
 */
export class MdCardLgImage {static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[md-card-lg-image], [mat-card-lg-image], [mdCardImageLarge], [matCardImageLarge]',
  host: {'class': 'mat-card-lg-image'}
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function MdCardLgImage_tsickle_Closure_declarations() {
/** @type {?} */
MdCardLgImage.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdCardLgImage.ctorParameters;
}

/**
 * Large image used in a card, needed to add the mat- CSS styling.
 * \@docs-private
 */
export class MdCardXlImage {static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[md-card-xl-image], [mat-card-xl-image], [mdCardImageXLarge], [matCardImageXLarge]',
  host: {'class': 'mat-card-xl-image'}
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function MdCardXlImage_tsickle_Closure_declarations() {
/** @type {?} */
MdCardXlImage.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdCardXlImage.ctorParameters;
}

/**
 * Avatar image used in a card, needed to add the mat- CSS styling.
 * \@docs-private
 */
export class MdCardAvatar {static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[md-card-avatar], [mat-card-avatar], [mdCardAvatar], [matCardAvatar]',
  host: {'class': 'mat-card-avatar'}
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function MdCardAvatar_tsickle_Closure_declarations() {
/** @type {?} */
MdCardAvatar.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdCardAvatar.ctorParameters;
}

/**
 * A basic content container component that adds the styles of a Material design card.
 * 
 * While this component can be used alone, it also provides a number
 * of preset styles for common card sections, including:
 * - md-card-title
 * - md-card-subtitle
 * - md-card-content
 * - md-card-actions
 * - md-card-footer
 */
export class MdCard {static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  moduleId: module.id,
  selector: 'md-card, mat-card',
  templateUrl: 'card.html',
  styleUrls: ['card.css'],
  encapsulation: ViewEncapsulation.None,
  preserveWhitespaces: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {'class': 'mat-card'}
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function MdCard_tsickle_Closure_declarations() {
/** @type {?} */
MdCard.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdCard.ctorParameters;
}

/**
 * Component intended to be used within the `<md-card>` component. It adds styles for a
 * preset header section (i.e. a title, subtitle, and avatar layout).
 * \@docs-private
 */
export class MdCardHeader {static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  moduleId: module.id,
  selector: 'md-card-header, mat-card-header',
  templateUrl: 'card-header.html',
  encapsulation: ViewEncapsulation.None,
  preserveWhitespaces: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {'class': 'mat-card-header'}
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function MdCardHeader_tsickle_Closure_declarations() {
/** @type {?} */
MdCardHeader.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdCardHeader.ctorParameters;
}

/**
 * Component intended to be used within the <md-card> component. It adds styles for a preset
 * layout that groups an image with a title section.
 * \@docs-private
 */
export class MdCardTitleGroup {static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  moduleId: module.id,
  selector: 'md-card-title-group, mat-card-title-group',
  templateUrl: 'card-title-group.html',
  encapsulation: ViewEncapsulation.None,
  preserveWhitespaces: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {'class': 'mat-card-title-group'}
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function MdCardTitleGroup_tsickle_Closure_declarations() {
/** @type {?} */
MdCardTitleGroup.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdCardTitleGroup.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
